import { ArrowLeftIcon } from '@grupoboticario/flora-react-icons';
import { app } from 'core';
import { HeaderPage } from 'ui/components';
import { HeaderLogo } from 'ui/containers/SectionBuilder/sections/Header/widgets';
import { useRedirectToCart } from 'ui/hooks/useRedirectToCart';

import { GiftStyles } from './Gifts.styles';

const GiftsHeader = () => {
  const { redirectToCart } = useRedirectToCart();
  const { trackClick } = app.commands.useAppCommand();

  const handleBackToCart = (
    event: React.MouseEvent<HTMLButtonElement> | React.UIEvent<HTMLButtonElement>,
  ) => {
    trackClick(event);
    redirectToCart();
  };

  return (
    <HeaderPage
      testid="header-page"
      button={
        <GiftStyles.Header.Button onClick={handleBackToCart}>
          <ArrowLeftIcon />
          <span>Alterar pedido</span>
        </GiftStyles.Header.Button>
      }
    >
      <HeaderLogo />
    </HeaderPage>
  );
};

export default GiftsHeader;
